export const contactsData = {
    name:'Manpreet Mann',
    email: 'manpreetmann4788@gmail.com',
    phone: '',
    address: 'Jalandhar, Punjab',
    github: 'https://github.com/manpreet-mann',
    linkedIn: 'https://www.linkedin.com/in/manpreet-mann/',
    leetcode:'',
    twitter:'https://x.com/manpreetmann33',
    resume: 'https://drive.google.com/file/d/1Etqa1n0-FCYq7QcjIuk8K7GgHNK-TbtL/view?usp=sharing',
    aboutMe:'I am a recent B.Tech graduate specializing in Computer Science & Engineering from I.K. Gujral Punjab Technical University, Kapurthala. My skill set includes proficiency in React, HTML5, CSS3, JavaScript, Bootstrap, and Figma. Additionally, I am expanding my expertise in backend development using Node.js, Express, and MongoDB. I also possess a strong foundation in C++.'
}